import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import { useUserStore } from '../../../store/useUserStore';
import { useVideosByMonthQuery } from '../../../queries';
import ImgNoThumbnail from '../../../assets/image/img_video_no_thumbnail.png';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';

function AllVideos() {
  const navigate = useNavigate();
  const user = useUserStore();
  const [allVideosArray, setAllVideosArray] = useState<any[]>([]);

  const { data: videos = {} } = useVideosByMonthQuery(user.id as number, { enabled: !!user.id });

  // videos 객체를 하나의 배열로 변환하고 createdAt 기준 최신순으로 정렬
  useEffect(() => {
    if (!videos || typeof videos !== 'object') {
      setAllVideosArray([]);
      return;
    }
    const videoArray: any[] = [];
    Object.keys(videos).forEach((monthKey) => {
      if (Array.isArray(videos[monthKey])) {
        videoArray.push(...videos[monthKey]);
      }
    });
    videoArray.sort((a, b) => {
      const dateA = new Date(a.createdAt).getTime();
      const dateB = new Date(b.createdAt).getTime();
      return dateB - dateA;
    });
    setAllVideosArray(videoArray);
  }, [videos]);

  // allVideosArray를 createdAt 기준으로 월별로 그룹화
  const groupVideosByMonth = (videoArray: any[]) => {
    const grouped: { [key: string]: any[] } = {};
    videoArray.forEach((video) => {
      if (!video.createdAt) return;
      const date = new Date(video.createdAt);
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      if (!grouped[monthKey]) {
        grouped[monthKey] = [];
      }
      grouped[monthKey].push(video);
    });
    const sortedMonths = Object.keys(grouped).sort((a, b) => b.localeCompare(a));
    return sortedMonths.map((monthKey) => ({
      monthKey,
      videos: grouped[monthKey],
    }));
  };

  const groupedVideos = groupVideosByMonth(allVideosArray);

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="전체 보기" onClickPrev={() => navigate(-1)} />
      <div className="pageInner" style={{ padding: '0 0 50px 0' }}>
        {groupedVideos.map((group) => {
          return (
            <div className="w-full" key={group.monthKey}>
              <div className="text-[18px] text-[1C1C1C] w-full text-left font-[700] pt-[20px] pb-[15px] px-[20px]">
                {group.monthKey?.split('-')[1]}월
              </div>
              <div className="grid grid-cols-3 gap-[5px] px-[20px]">
                {group.videos?.map((video) => {
                  const videoIndex = allVideosArray.findIndex((v) => v.mediaId === video.mediaId);
                  return (
                    <button
                      type="button"
                      onClick={() =>
                        navigate(Url.HistoryWatchVideo, {
                          state: { videos: allVideosArray, videoIndex },
                        })
                      }
                      key={video.mediaId}
                      style={{ aspectRatio: '1 / 1' }}
                      className="w-full bg-[#F8F8F8] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]"
                    >
                      <img
                        src={video?.thumbnailUrl ?? ImgNoThumbnail}
                        alt={`Video ${video.mediaId}`}
                        className="w-full h-full object-cover rounded-[10px]"
                      />
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </FullHeightContainer>
  );
}

export default AllVideos;
